import { Routes } from '@angular/router';
import { RoleGuard } from './guards/role.guard';
import { Role } from './models/roles-permissions.model';
import { NgxPermissionsRouterData } from 'ngx-permissions';
import { vendorGuard } from './guards/vendor.guard';

export const AUTHENTICATION_ROUTES: Routes = [
  {
    path: "",
    redirectTo: "my-account",
    pathMatch: "full",
  },
  {
    path: "my-account",
    loadComponent: () =>
      import("./components/my-account/my-account.component").then(
        (m) => m.MyAccountComponent
      ),
  },
  {
    path: "Signup",
    loadComponent: () =>
      import("./components/signup/signup.component").then(
        (m) => m.SignupComponent
      ),
  },
  {
    path: "ForgotPassword",
    loadComponent: () =>
      import("./components/forgot-password/forgot-password.component").then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: "otp",
    loadComponent: () =>
      import("./components/login-with-otp/login-with-otp.component").then(
        (m) => m.LoginWithOTPComponent
      ),
  },
  {
    path: "otpAuthentication",
    loadComponent: () =>
      import(
        "./components/otp-authentication/otp-authentication.component"
      ).then((m) => m.OtpAuthenticationComponent),
  },
  {
    path: "vendor/edit/updateVendor",
    // Converted to loadComponent for better performance
    loadComponent: () =>
      import(
        "./components/vendor-collect-details/vendor-information/vendor-information.component"
      ).then((m) => m.VendorInformationComponent),
    resolve: { data: vendorGuard },
  },
  {
    path: "verify-vendor-otp",
    loadComponent: () =>
      import("./components/vendor-otp-verify/vendor-otp-verify.component").then(
        (m) => m.VendorOtpVerifyComponent
      ),
  },
  {
    path: "register-seller",
    loadComponent: () =>
      import(
        "./components/vendor-collect-details/seller-registration/seller-registration.component"
      ).then((m) => m.SellerRegistrationComponent),
  },
  {
    path: "changePassword",
    canActivate: [RoleGuard],
    data: {
      roles: {
        only: [
          Role.Customer,
          Role.Vendor,
          Role.WholeSaler,
          Role.BusinessCustomer,
          Role.SiteAdministrator,
        ],
        redirectTo: "/error/access-denied",
      } as NgxPermissionsRouterData,
    },
    loadComponent: () =>
      import("./components/change-password/change-password.component").then(
        (m) => m.ChangePasswordComponent
      ),
  },
];